import { CFAuthGetRef } from "auth";
import { locations } from './action_locations';
import { AGENT_LOCATION_FLAG, RECEIVE_AGENT_LOCATION_FLAG } from './constants';

async function getAgentVerificationLocationFlag(userID) {
  // location API
  return CFAuthGetRef({
    url: `${process.env.REACT_APP_AP_API_URL}/AgentVerification/AgentLocationCache/${userID}`,
    originURL: process.env.PUBLIC_URL,
    params: null,
    loaderName: ''
  });
}

function receivedAgentVerificationLocationFlag(verificationLocationEnabled) {
  return {
		type: RECEIVE_AGENT_LOCATION_FLAG,
    verificationLocationEnabled: verificationLocationEnabled.success
	}
}

export function agentVerificationLocationFlagAction(filters) {
	return {
    type: AGENT_LOCATION_FLAG,
    fetchCall: getAgentVerificationLocationFlag,
    receivedAction: receivedAgentVerificationLocationFlag,
    data: { locations, filters }
  }
}

export function reducer(state, { 
  type,
  verificationLocationEnabled
}) {
  switch (type) {
    case RECEIVE_AGENT_LOCATION_FLAG:
      return {
        ...state,
        verificationLocationEnabled
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/agentVerificationLocationFlag.js